import { Pipe, PipeTransform } from '@angular/core';

import { UserInfoService } from '../../services/user-info/user-info.service';

@Pipe({
  name: 'checkPermissions',
  pure: false
})
export class CheckPermissionsPipe implements PipeTransform {

  constructor(private readonly userInfo: UserInfoService) {}

  /**
   * Check permission is present
   * @param permissions Permisions list
   * @returns True if access is granted or False if it's denied
   */
  transform(permissions: Array<string>): boolean {
    return permissions.some(permission => this.userInfo.getPermissions(permission));
  }

}
